<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
  inSidebar: {
    type: Boolean,
    default: false,
  },
});

function getText({ title, text }) {
  let result = '';

  if (title) result += `<p><strong>${title}</strong></p>`;
  if (text) result += text;

  return result;
}
</script>

<template>
  <div class="ctr-list-icon-blocks" :class="{ container: !inSidebar }">
    <div class="ctr-list-icon-blocks__wrapper">
      <div class="ctr-list-icon-blocks__items">
        <div
          v-for="(item, index) in items"
          :key="`item-${index}`"
          class="ctr-list-icon-blocks__item"
        >
          <div class="ctr-list-icon-blocks__img-container">
            <img
              v-if="item?.icon"
              :src="item.icon"
              alt="icon"
              class="ctr-list-icon-blocks__img"
            />
          </div>

          <div class="ctr-list-icon-blocks__font">
            <UiHtmlContent
              v-if="item?.title || item?.text"
              custom-font
              :content="getText(item)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ctr-list-icon-blocks {
  &__wrapper {
    overflow: auto hidden;
    @include hide-scroll;

    @include media-breakpoint-down(sm) {
      margin: 0 em(-$gap-sm);
    }
  }

  &__items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }

  &__img-container {
    margin-bottom: em(78);
    height: em(203);

    @include media-breakpoint-down(sm) {
      margin-bottom: em(43);
      height: em(173);
    }
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: left top;
  }

  &__item {
    padding: em(39) em(38);
    border: 1px solid $color-gray-1;

    &:not(:last-child) {
      margin-right: -1px;
    }

    @include media-breakpoint-down(sm) {
      flex: 0 0 auto;
      padding: em(25) em(28);
      width: em(269);
    }
  }

  &__font {
    font-size: em(18);
    line-height: em(23, 18);
    font-weight: 250;

    @include media-breakpoint-down(sm) {
      font-size: em(16);
      line-height: em(21, 16);
    }
  }
}
</style>
